/* eslint-disable */
import { SpecificationsData } from './specification.mock';
export const CurrentItemWithSpecData = {
  make: 'Bosch',
  model: 'DFG 15B1',
  appliance_category: 'Washing Machine',
  short_description: 'Bosch Washing Machine Energy A+',
  long_description: 'Bosch Washing Machine Energy A+ W 65cm',
  images: [
    {
      text: 'Front',
      url: '',
    },
  ],
  compare_specs: SpecificationsData,
};

export const CurrentItemNoSpecData = {
  make: 'Bosch',
  model: 'DFG 15B1',
  appliance_category: 'Washing Machine',
  short_description: 'Bosch Washing Machine Energy A+',
  long_description: 'Bosch Washing Machine Energy A+ W 65cm',
  images: [
    {
      text: 'Front',
      url: '',
    },
  ],
  compare_specs: [],
};
